import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCTSGUIDE_SUCCESS,
    GET_PRODUCTSGUIDE_FAILURE,
} from '../actions/actionTypes';

import { getProductsGuideDataService } from '../../services';

export default function* getProductsGuide() {
    try {
        const result = yield getProductsGuideDataService();
        yield put({ type: GET_PRODUCTSGUIDE_SUCCESS, productsGuide: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `/occ/v2/${localStorage.getItem('baseSiteId')}/productsGuide`
        });
        yield put({
            type: GET_PRODUCTSGUIDE_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}